import { Colors } from '../../colors';
import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const CloseLine = ({ width = 18, height = 18, fill = Colors.gray700, ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={fill}
        d="M8.99989 9.7902L5.19514 13.5951C5.09126 13.6989 4.9607 13.752 4.80345 13.7545C4.64632 13.7569 4.51339 13.7038 4.40464 13.5951C4.29601 13.4864 4.2417 13.3546 4.2417 13.1999C4.2417 13.0451 4.29601 12.9134 4.40464 12.8046L8.20957 8.99989L4.40464 5.19514C4.30089 5.09126 4.24776 4.9607 4.24526 4.80345C4.24289 4.64632 4.29601 4.51339 4.40464 4.40464C4.51339 4.29601 4.64514 4.2417 4.79989 4.2417C4.95464 4.2417 5.08639 4.29601 5.19514 4.40464L8.99989 8.20957L12.8046 4.40464C12.9085 4.30089 13.0391 4.24776 13.1963 4.24526C13.3534 4.24289 13.4864 4.29601 13.5951 4.40464C13.7038 4.51339 13.7581 4.64514 13.7581 4.79989C13.7581 4.95464 13.7038 5.08639 13.5951 5.19514L9.7902 8.99989L13.5951 12.8046C13.6989 12.9085 13.752 13.0391 13.7545 13.1963C13.7569 13.3534 13.7038 13.4864 13.5951 13.5951C13.4864 13.7038 13.3546 13.7581 13.1999 13.7581C13.0451 13.7581 12.9134 13.7038 12.8046 13.5951L8.99989 9.7902Z"
      />
    </Svg>
  );
};

export default CloseLine;
